import { render, staticRenderFns } from "./BulletPointsUpdate.vue?vue&type=template&id=7471e6f4&"
import script from "./BulletPointsUpdate.vue?vue&type=script&lang=js&"
export * from "./BulletPointsUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports